import { BaseControlBehaviour } from "./BaseControlBehaviour";

export function unbindWindowWarning() {
    window.onbeforeunload = null;
}

export class CustomFileBehaviour extends BaseControlBehaviour {
    constructor() {
        super('custom-file');
    }

    public static deleteFile(removeButton, parentSelector, fileSelector) {
        const parent = $(removeButton).parent(parentSelector);
        const file = $(fileSelector, parent);

        if (file.val() != '') {
            const isConfirmed = confirm(
                Localization.getString(
                    'FileControls.DeleteFile',
                    'Удалить файл?'
                )
            );
            if (isConfirmed) {
                file.val('');
                $(removeButton)
                    .siblings('label')
                    .children('mark')
                    .text(
                        Localization.getString(
                            'FileControls.NoFiles',
                            'Файл не выбран'
                        )
                    );
                $(removeButton).css('display', 'none');
            }
        }

        const fileNames = [];
        const totalFiles = $(parentSelector).find('[type="file"]');

        const labelCssClass = $(file).attr('custom-file-label-class');
        if (labelCssClass) {
            $(parent).siblings('.j-upload-label').removeClass(labelCssClass);
        }

        $.each(totalFiles, function (i, item) {
            const value = $(totalFiles[i]).val();
            if (value != '') {
                fileNames.push(value);
            }
        });

        if (fileNames.length == 0) window.onbeforeunload = null;
    }

    public static clearFileInput(removeButton, parentSelector, fileSelector) {
        const parent = $(removeButton).closest(parentSelector);
        const file = $(fileSelector, parent)[0];

        $(file).val('');

        const labelCssClass = $(file).attr('custom-file-label-class');
        if (labelCssClass) {
            $('.j-upload-label', parent).removeClass(labelCssClass);
        }
        $(file).siblings('.j-upload-value').text('');
    }

    private static RollbackFileControls(
        inputElement: any,
        uploadButton: JQuery
    ) {
        const inputWrapper = $(inputElement);
        inputWrapper.val('');
        if (inputElement.files.length > 0) inputElement.files[0] = null;
        if (uploadButton.length > 0) {
            uploadButton.addClass('m-disabled');
        }
        $('[custom-file-uploadPath-element]').text(
            window.Localization.getString(
                'Scripts_Shared_Infrastructure.CustomFileBehaviour_3',
                'Загрузить файл'
            )
        );
    }

    protected installBehaviour(element: HTMLElement) {
        $(element).attr('custom-file-installed', 'true');
        const clearFileInputButtonSelector = $(element).attr(
            'custom-file-clear-button'
        );
        if (clearFileInputButtonSelector) {
            $(element)
                .siblings(clearFileInputButtonSelector)
                .click((evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $(evt.target);
                    const parentSelector =
                        $(evt.target).attr('parent-selector') || 'div';
                    const fileSelector =
                        $(evt.target).attr('file-selector') ||
                        'input[type=file]';

                    CustomFileBehaviour.clearFileInput(
                        evt.target,
                        parentSelector,
                        fileSelector
                    );
                });
        }
        $(element).change(function () {
            let isError = false;
            let errorMessage = '';

            const maxUSerSize = parseInt($(this).attr('custom-file-max-size')); //мегабайты
            const maxSizeBytes: number = maxUSerSize * 1024 * 1024; //байты
            const uploadButton = $('[custom-file-uploadButton]');
            if (this.files.length == 0) {
                CustomFileBehaviour.RollbackFileControls(this, uploadButton);
                return;
            }
            const fileSize: number = this.files[0].size;

            if (fileSize > maxSizeBytes) {
                errorMessage =
                    Localization.getString(
                        'FileControls.MaxUserSize1',
                        'Размер файла не должен превышать '
                    ) +
                    maxUSerSize +
                    Localization.getString('FileControls.MaxUserSize2', ' Мб');
                isError = true;
            }

            const allowedExtensions = $(this)
                .attr('custom-file-extensions')
                .split(',');
            const fileName: string = $(this).val();
            const extension: string = fileName.replace(/^.*\./, '');

            if ($.inArray(extension, allowedExtensions) == -1) {
                errorMessage =
                    Localization.getString(
                        'FileControls.AllowedExtensions1',
                        'Допускаются только '
                    ) +
                    allowedExtensions.toString() +
                    Localization.getString(
                        'FileControls.AllowedExtensions2',
                        ' расширения файлов'
                    );
                isError = true;
            }

            if (isError) {
                alert(errorMessage);
                CustomFileBehaviour.RollbackFileControls(this, uploadButton);
            } else {
                if (uploadButton.length > 0) {
                    uploadButton.removeClass('m-disabled');
                }
                const uploadPathElement = $('[custom-file-uploadPath-element]');
                $(this).siblings('.j-upload-value').text($(element).val());

                const labelCssClass = $(this).attr('custom-file-label-class');
                if (labelCssClass) {
                    $(this).siblings('.j-upload-label').addClass(labelCssClass);
                }

                if (uploadPathElement.length > 0) {
                    uploadPathElement.html(fileName.split(/(\\|\/)/g).pop());
                }

                if (
                    $(this).attr('custom-file-warning') == 'true' &&
                    this.files[0] != null
                ) {
                    window.onbeforeunload = function () {
                        return Localization.getString(
                            'FileControls.FilesWillBeDeleted',
                            'При перезагрузке страницы прикрепленные файлы будут удалены'
                        );
                    };
                }
            }
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.CustomFileBehaviour = CustomFileBehaviour;
window.Behaviours.unbindWindowWarning = unbindWindowWarning;